import { Action } from '@ngrx/store';

import { Domain } from 'modules/shared/models/domain.models';
import { DomainPayload } from 'store/models/domain.models';

/**
 * For each action type in an action group, make a simple
 * enum object for all of this group's action types.
 */
export enum DomainActionTypes {
  LOAD_DOMAIN_LIST = 'LOAD_DOMAIN_LIST',
  LOAD_DOMAIN_LIST_SUCCESS = 'LOAD_DOMAIN_LIST_SUCCESS',
  LOAD_DOMAIN_LIST_FAILURE = 'LOAD_DOMAIN_LIST_FAILURE',
  CLEAR_LOAD_DOMAIN_LIST = 'CLEAR_LOAD_DOMAIN_LIST',
  SET_DOMAIN = 'SET_DOMAIN',
  CHANGE_DOMAIN = 'CHANGE_DOMAIN',
  CREATE_DOMAIN = 'CREATE_DOMAIN',
  CREATE_DOMAIN_SUCCESS = 'CREATE_DOMAIN_SUCCESS',
  CREATE_DOMAIN_FAILURE = 'CREATE_DOMAIN_FAILURE',
}

export type DomainActions
  = LoadList
  | LoadListSuccess
  | LoadListFailure
  | ChangeDomain
  | SetDomain;

export class LoadList implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.LOAD_DOMAIN_LIST;
  constructor(public payload: any = null) { }
}

export class LoadListSuccess implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.LOAD_DOMAIN_LIST_SUCCESS;
  constructor(public payload: any = null) { }
}

export class LoadListFailure implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.LOAD_DOMAIN_LIST_FAILURE;
  constructor(public payload: any = null) { }
}

export class ClearLoadList implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.CLEAR_LOAD_DOMAIN_LIST;
  constructor(public payload: any = null) { }
}

export class SetDomain implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.SET_DOMAIN;
  constructor(public payload: Domain = null) { }
}

export class CreateDomain implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.CREATE_DOMAIN;
  constructor(public payload: DomainPayload = null) { }
}

export class CreateDomainSuccess implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.CREATE_DOMAIN_SUCCESS;
  constructor(public payload: Domain = null) { }
}

export class CreateDomainFailure implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.CREATE_DOMAIN_FAILURE;
  constructor(public payload: any = null) { }
}

export class ChangeDomain implements Action {
  readonly type: DomainActionTypes = DomainActionTypes.CHANGE_DOMAIN;
  constructor(public payload: Domain = null) { }
}
